import MobileIllustration from '../components/Illustrations/MobileIllustration';
import EyeIllustration from '../components/Illustrations/EyeIllustration';
import KeyIllustration from '../components/Illustrations/KeyIllustration';
import EnvelopeAnimation from '../components/Illustrations/EnvelopeIllustration';

export const HOW_IT_WORKS_STEPS = [
  {
    titleKey: 'how_it_works.step1.title',
    descriptionKey: 'how_it_works.step1.description',
    renderImage: ({ className }) => <EyeIllustration className={className} />,
    bulletPoints: [
      {
        titleKey: 'how_it_works.step1.bullet1.title',
        textKey: 'how_it_works.step1.bullet1.text'
      },
      {
        titleKey: 'how_it_works.step1.bullet2.title',
        textKey: 'how_it_works.step1.bullet2.text'
      }
    ],
    cta: {
      textKey: 'how_it_works.step1.cta.text',
      routeId: 'landing'
    }
  },
  {
    titleKey: 'how_it_works.step2.title',
    descriptionKey: 'how_it_works.step2.description',
    renderImage: ({ className }) => <EnvelopeAnimation className={className} />,
    bulletPoints: [
      {
        titleKey: 'how_it_works.step2.bullet1.title',
        textKey: 'how_it_works.step2.bullet1.text'
      },
      {
        titleKey: 'how_it_works.step2.bullet2.title',
        textKey: 'how_it_works.step2.bullet2.text'
      }
    ]
  },
  {
    titleKey: 'how_it_works.step3.title',
    descriptionKey: 'how_it_works.step3.description',
    renderImage: ({ className }) => (
      <MobileIllustration className={className} />
    ),
    bulletPoints: [
      {
        titleKey: 'how_it_works.step3.bullet1.title',
        textKey: 'how_it_works.step3.bullet1.text'
      },
      {
        titleKey: 'how_it_works.step3.bullet2.title',
        textKey: 'how_it_works.step3.bullet2.text'
      }
    ]
  },
  {
    titleKey: 'how_it_works.step4.title',
    descriptionKey: 'how_it_works.step4.description',
    renderImage: ({ className }) => <KeyIllustration className={className} />,
    bulletPoints: [
      {
        titleKey: 'how_it_works.step4.bullet1.title',
        textKey: 'how_it_works.step4.bullet1.text'
      },
      {
        titleKey: 'how_it_works.step4.bullet2.title',
        textKey: 'how_it_works.step4.bullet2.text'
      },
      {
        titleKey: 'how_it_works.step4.bullet3.title',
        textKey: 'how_it_works.step4.bullet3.text'
      }
    ]
  }
];
